import { z } from 'zod';
/**
 * Alkalmazas-ikonok.
 *
 * MIND UGYANAZ A JEL: a ket egymasnak dolo beszedbuborek geometriaja egy
 * keppontot sem valtozik. Egy variansban CSAK a szinek mas: a csempe ket
 * gradiensvege, az elulso es a hatso buborek. Ezert nincs variansonkent SVG
 * fajl - egy variansnak negy hex ertek a teljes definicioja, es az itt van.
 *
 * ─── Miert kell egyaltalan valasztani? ──────────────────────────────────────
 *
 * A petrol csempe szep, de egy munkahelyi talcan ELTUNIK: a kek a
 * legzsufoltabb szin ott (levelezo, bongeszo, kodszerkeszto, videohivas,
 * maga a rendszer). Nem halvany - csak nincs mitol kilogjon a sorbol.
 * A tobbi paletta ezert mind KILEP a kek kornyekerol, mas-mas iranyba.
 *
 * ─── Miert innen veszi mindenki? ────────────────────────────────────────────
 *
 * Harom helyen kell ugyanaz a negy szin: a feluleten (`LogoTile`), a
 * PNG-keszlet generalasakor (`apps/web/scripts/gen-icons.mjs`) es a
 * manifestben. Ha harom helyen allna, elobb-utobb elcsuszna - ugyanaz az
 * indok, amiert a jel eleve kodban van, nem kepfajlban.
 */
export const appIcons = ['petrol', 'korall', 'malna', 'napsarga', 'neon', 'lime'];
export const appIconSchema = z.enum(appIcons);
/**
 * A hatso buborek MINDIG mas szincsaladbol jon, mint a csempe.
 *
 * Nem izles kerdese: a ket buborek kozti res ettol lathato. Ha a hatso a
 * csempehez hasonlo, apro mereten a ket alak egyetlen foltta olvad - eppen az
 * oleles tunik el az oleles-jelbol.
 */
export const APP_ICONS = {
    petrol: {
        name: 'Petrol',
        tileTop: '#1E738E',
        tileBottom: '#00627E',
        front: '#FAF8F5',
        back: '#BC593A',
        hint: 'Az eredeti. Visszafogott, de egy zsúfolt tálcán könnyen eltűnik.',
    },
    korall: {
        name: 'Korall',
        tileTop: '#FF6B45',
        tileBottom: '#E03A16',
        front: '#FFF7F0',
        back: '#12B3A0',
        hint: 'A terrakotta lesz a főszereplő. A türkiz hátsó buborék tartja a rést.',
    },
    malna: {
        name: 'Málna',
        tileTop: '#F0289B',
        tileBottom: '#B00E6E',
        front: '#FFF2FA',
        back: '#FFD43B',
        hint: 'Egy céges tálcán gyakorlatilag nincs magenta - ez találja meg magát a leggyorsabban.',
    },
    napsarga: {
        name: 'Napsárga',
        tileTop: '#FFD028',
        tileBottom: '#F5A300',
        front: '#2B2118',
        back: '#E03131',
        hint: 'Fordított fényerő: sötét jel világos csempén. 16 képpontnál ez a legolvashatóbb.',
    },
    neon: {
        name: 'Neon',
        tileTop: '#262B3A',
        tileBottom: '#0E1119',
        front: '#3DE8A0',
        back: '#FF4D8D',
        hint: 'Majdnem fekete csempe, világító jellel. Sötét tálcán ez a legerősebb.',
    },
    lime: {
        name: 'Lime',
        tileTop: '#BFF23F',
        tileBottom: '#7FBE0A',
        front: '#1B2508',
        back: '#FF5722',
        hint: 'Savas zöld, sötét jellel. A mezőny legbátrabb vége.',
    },
};
export const DEFAULT_APP_ICON = 'petrol';
/**
 * Az ikonkeszlet utja egy varianshoz.
 *
 * A fajlnevek variansonkent AZONOSAK, csak a mappa mas - igy a hivo oldalon
 * nem kell nevtablazatot vezetni, es egy uj varians nulla kodvaltozas.
 */
export const appIconPath = (icon, file) => `/icons/${icon}/${file}`;
//# sourceMappingURL=app-icons.js.map